var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"toggle-button",class:_vm.value ? 'active' : '',on:{"click":_vm.changeValue}})}
var staticRenderFns = []

export { render, staticRenderFns }